import classNames from 'classnames';
import { CreateTag } from './CreateTag';
import { PopoverSelector } from '@ui/PopoverSelector';
import { SonarTagDisplay } from '.';
import { useTags } from '@hooks';
import { FULL_ROUTES, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useCallback, useState } from 'react';
export const TagPicker = ({ className, children, onDeselect, onSelect, selectedTagIds = [], singleSelect, trigger = 'hover' }) => {
    const tags = useTags();
    const [filterValue, setFilterValue] = useState('');
    const matchesFilter = useCallback((value) => {
        if (filterValue === '') {
            return true;
        }
        return value.name.toLowerCase().includes(filterValue.toLowerCase().trim());
    }, [filterValue]);
    const renderTagItem = (tag) => React.createElement(SonarTagDisplay, { noBorder: true, tagId: tag.id });
    return (React.createElement(PopoverSelector, { className: classNames('tag-picker', className), footer: React.createElement(CreateTag, { onFinish: onSelect }), itemRender: renderTagItem, listItems: tags.filter((tag) => !tag.autoTagged).filter(matchesFilter), manageRoute: FULL_ROUTES.TAGS_MANAGE, onDeselect: (tag) => onDeselect(tag.id), onSearch: setFilterValue, onSelect: (tag) => onSelect(tag.id), placeholder: PLACEHOLDERS_COPY.SEARCH_TAGS, selectedIds: selectedTagIds, singleSelect: singleSelect, trigger: trigger },
        React.createElement("div", null, children)));
};
